/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_ToInputs */

const en_wb_sales_to = /** @type {(inputs: Wb_Sales_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To: Alex · North Studio`)
};

const lv_wb_sales_to = /** @type {(inputs: Wb_Sales_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kam: Alex · North Studio`)
};

/**
* | output |
* | --- |
* | "To: Alex · North Studio" |
*
* @param {Wb_Sales_ToInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_to = /** @type {((inputs?: Wb_Sales_ToInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_ToInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_to(inputs)
	return en_wb_sales_to(inputs)
});